import React from 'react';
import { InterviewTab } from '@/components/interview/InterviewTab';

interface CalendlyTabProps {
  candidate: {
    full_name: string;
    email?: string;
    calendly_url?: string;
  };
  testResponseId: string;
  interviewInvitedAt?: string | null;
}

export function CalendlyTab({ candidate, testResponseId, interviewInvitedAt }: CalendlyTabProps) {
  return (
    <InterviewTab 
      candidate={{
        full_name: candidate.full_name,
        email: candidate.email || '',
        calendly_url: candidate.calendly_url
      }}
      testResponseId={testResponseId}
      interviewInvitedAt={interviewInvitedAt}
    />
  );
}